import { render } from "./Condoleances.vue?vue&type=template&id=2d8869fe&scoped=true"
import script from "./Condoleances.vue?vue&type=script&lang=js"
export * from "./Condoleances.vue?vue&type=script&lang=js"

import "./Condoleances.vue?vue&type=style&index=0&id=2d8869fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8869fe"]])

export default __exports__